import React, { useState } from "react";
import StoryCard from 'common/components/modules/story-card';
import ImageContent from 'common/components/modules/story-player/contents/image';
import Icon from 'common/components/elements/icons';
import PropTypes from 'prop-types';
import ImageStoryCardContent from 'common/components/modules/story-card/image';
import StoryBottomContent from 'common/components/modules/story-bottom-content';
import TimeSector from 'common/components/elements/time-sector';
import moment from 'moment';
import DateFormatter from 'common/utils/DateFormatter';
import './style.scss'
import { connect } from "react-redux";
import { screenWidthSelector } from "admin/state/modules/common/selectors";
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css'
import TruncateText from 'common/components/elements/truncate-text';
import { filterBadWords } from "common/utils/filter-bad-words";
import { MediaButtonWrapper } from "common/components/modules/media";

const SamplePrevArrow = (props) => {
   const { onClick, carouselState: { currentSlide }, clearInterval } = props;
   const dis = currentSlide === 0
   return (
      <div
         role='presentation'
         className={ `carousel-prev w-8 h-8 bg-red my-auto absolute top-0 mx-2 left-0 bottom-0 z-2 flex items-center justify-center ${ dis ? 'opacity-50' : 'cursor-pointer' }` }
         onClick={ (e) => {
            if(!dis && onClick) {
               onClick(e);
               clearInterval && clearInterval()
            }
            e.stopPropagation();
         } }
      >
         <div className='carousel-botton mms-media-button-wrapper-bg rounded-full outline-none h-8 w-8 flex items-center justify-center group hover:bg-panel duration-300'>
            <Icon
               name='arrow-left'
               color='major-dark'
               size='xl'
               className='group-hover:!text-secondary duration-300'
            />
         </div>
      </div>
   );
};

const SampleNextArrow = (props) => {
   const { onClick, carouselState, clearInterval, type } = props;
   const totalItems = type === 'fullScreen' ? carouselState.totalItems - 1 : carouselState.totalItems
   const dis = totalItems - carouselState.currentSlide === 1
   return (
      <div
         role='presentation'
         className={ `carousel-next w-8 h-8 bg-red my-auto absolute mx-2 bottom-0 top-0 right-0 z-2 flex items-center justify-center ${ false ? 'disabled-arrow' : '' } ${ dis ? 'opacity-50' : 'cursor-pointer' }` }
         onClick={ (e) => {
            if(!dis && onClick) {
               onClick(e);
               clearInterval && clearInterval()
            }
            e.stopPropagation();
         } }
      >
         <div className='carousel-botton mms-media-button-wrapper-bg  rounded-full  outline-none h-8 w-8 flex items-center justify-center group hover:bg-panel duration-300'>
            <Icon
               name='arrow-right'
               color='major-dark'
               size='xl'
               className='group-hover:text-secondary duration-300'
            />
         </div>
      </div>
   );
};

class SimpleSlider extends React.Component {
   interval = null;
   prevRef = null;
   constructor(props){
      super(props);
      this.state = {
         isVisible: false,
      }
      this.carouselRef = React.createRef()
   }
   options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
   }



   callbackFunction = (entries) => {
      const { screenWidth, isAutoplay } = this.props;
      if(screenWidth > 1024 || !isAutoplay) {
         return;
      }
      const [entry] = entries;
      this.setState({
         isVisible: entry.isIntersecting,
      })
      if(!this.carouselRef.current) return
      if(this.state.isVisible) {
         this.next()
      } else {
         this.previous();
      }
   }

   observer = new IntersectionObserver(this.callbackFunction, this.options)

   componentDidMount() {
      if(!this.carouselRef.current) return;
      if(this.carouselRef.current){
         let child = this.carouselRef.current?.childNodes[0];
         this.prevRef = this.carouselRef.current;
         this.observer.observe(child)
      }
      if(this.Carousel && this.props.initialSlideNumber !== 0){
         this.Carousel.goToSlide(this.props.initialSlideNumber);
      }
   }

   componentDidUpdate(prevProps) {
      if(!this.carouselRef.current) return;
      if(this.Carousel && prevProps.initialSlideNumber !== this.props.initialSlideNumber) {
         this.Carousel.goToSlide(this.props.initialSlideNumber);
      }
      if(this.prevRef !== this.carouselRef.current){
         let child = this.carouselRef.current?.childNodes[0];
         this.observer.observe(child)
      }
      this.prevRef = this.carouselRef.current;
   }
   componentWillUnmount() {
      if(!this.carouselRef.current) return;
      if(this.carouselRef.current){
         let child = this.carouselRef.current?.childNodes[0];
         this.observer.unobserve(child)
      }
   }
   next = () => {
      if(!this.interval){
         this.Carousel && this.Carousel.next();
      }
      this.interval = setInterval(() => {
         this.Carousel && this.Carousel.next();
      }, 2000)
   }
   previous = () => {
      clearInterval(this.interval);
      this.interval = null;
   }

   responsive = {
      desktop: {
         breakpoint: { max: 3000, min: 1024 },
         items: 1,
      },
      tablet: {
         breakpoint: { max: 1024, min: 464 },
         items: 1,
      },
      mobile: {
         breakpoint: { max: 464, min: 0 },
         items: 1,
      },
   };

   render() {
      const {
         data,
         type = '',
         onClickComment,
         openModal,
         onClickJoin,
         onClickLike,
         onClickShare,
         openFullScreenCard,
         isAdmin,
         onClose,
         onClickOptions,
         isLiked,
         isAuthUsers,
         hasAccess,
         onDeleteImage,
         openStoryComments,
         children,
         onSliderChange,
         desktopType,
         openDeleteConfirmModal,
         shareStory,
         identifier,
         isAutoplay,
         isShowTopContent,
         isShowBottomContent,
         isDots,
         height,
         screenWidth,
         insideHomepage,
         activeStory,
         onClickTip,
         id,
         totalTip,
         onClickOpenTips,
         onClickSetId,
         onShare,
         siteInfo,
         isLockedForSFW,
         isAgeVerificationRequired,
         onClickVerifyButton,
         isInsideModal,
         isChecked,
         onSelectItem,
      } = this.props;
      let imgData = []
      let isMultipleCard = false
      if(type === 'image') {
         imgData = Array.isArray(data) ? data : []
         isMultipleCard = true;
      } else if(Array.isArray(data.full_src)) {
         imgData = data.full_src
         if(data.full_src.length > 1){
            isMultipleCard = true
         }
      }


      let isStoryCarusel = false;
      let hasTimeOut = false;
      let timeSector = null;
      let timeDifference = null;
      let storyDate = '';

      if(data && data.type === 'image' && type === 'card') {
         isStoryCarusel = true
         if(data && !!data.hideAfterMinutes) {
            hasTimeOut = true
            const result = DateFormatter.storyDate(data.publish_date, data.hideAfterMinutes)
            timeSector = result.sector
            timeDifference = result.time;
         }
         // eslint-disable-next-line no-unused-vars
         storyDate = (data && data.hideAfterMinutes) ? timeDifference : 'Published ' + moment(`${ data.publish_date }+00`).fromNow();
      }
      let settings = {
         afterChange: onSliderChange ? (...arg) => onSliderChange(...arg) : null,
         autoPlay: false,
         infinite: isAutoplay,
         transitionDuration: screenWidth < 1024 ? 700 : type === 'card' ? 600 : 0,
         autoPlaySpeed: 1000,
         customTransition: screenWidth < 1024 ? "all 0.7s ease" : '',
         swipeable: false,
         draggable: false,
         dotListClass: 'fullScreen_line absolute w-screen z-30 flex px-3',
         showDots: type === 'fullScreen' || isDots,
         arrows: (type === 'card' && (imgData.length > 1) && !insideHomepage) ||
         (type === 'image' && activeStory?.full_src.length > 1) || (type === 'fullScreen' && imgData.length > 1),
         customLeftArrow: <SamplePrevArrow clearInterval={ isAutoplay ? this.previous() : () => {} } isInterval={ this.interval } />,
         customRightArrow: <SampleNextArrow insideHomepage={ insideHomepage } type={ type }
            clearInterval={ isAutoplay ? this.previous() : () => {} } isInterval={ this.interval } />,
         renderArrowsWhenDisabled: true,
         containerClass: `carouse relative h-full  ${ type === 'fullScreen' ? 'fullwidth max-h-screen' : '' }
          ${ type === 'image' ? 'w-full h-full image-carousel dark:bg-panel-dark dark:text-major-dark bg-panel' : '' }`,
         itemClass: `h-full`,
         shouldResetAutoplay: false,
         responsive: this.responsive,
         partialVisible: false,
      }
      return (
         <div
            onMouseEnter={ (screenWidth > 1024 && isAutoplay && imgData.length > 1) ? this.next : () => {} }
            onMouseLeave={ (screenWidth > 1024 && isAutoplay && imgData.length > 1) ? this.previous : () => {} }
            className={ `w-full h-full ${ imgData.length > 1 ? 'multiple-slides' : '' }` }
            ref={ isMultipleCard && this.carouselRef }
         >
            <div className={ `w-full h-full ${ isStoryCarusel ? 'relative' : '' }` }>
               {
                  isStoryCarusel && isShowTopContent && (data?.title || hasTimeOut || isAdmin) && (
                     <div className='w-full absolute top-0 left-0 z-10'>
                        <div style={ { zIndex: 12 } } className='flex flex-col px-2 pt-2 gap-2 items-start'>
                           {
                              data && data.title && (
                                 <MediaButtonWrapper
                                    isCenter={ false }
                                 >
                                    <TruncateText
                                       text={ isAgeVerificationRequired ? filterBadWords(data.title) : data.title }
                                       // notranslate-content-title
                                       textClass='text-xl text-major-dark font-bold leading-tight select-none notranslate'
                                       textSize='20px'
                                       fontWeight='700'
                                    />
                                 </MediaButtonWrapper>
                              )
                           }
                           {
                              (hasTimeOut || isAdmin) && (
                                 <MediaButtonWrapper isCenter={ false } className='inline-flex select-none'>
                                    {hasTimeOut && <TimeSector angle={ timeSector } />}
                                    {isAdmin && <span className='text-sm text-major-dark'> {storyDate}</span>}
                                 </MediaButtonWrapper>
                              )
                           }
                        </div>
                     </div>
                  )
               }

               <Carousel
                  ref={ (el) => (this.Carousel = el) }
                  { ...settings }
               >
                  {imgData && imgData.map((item, index) => {
                     return (
                        <div key={ index.toString() }>
                           {
                              type === 'card' && (
                                 <>
                                    {
                                       isStoryCarusel ? (
                                          <ImageStoryContent
                                             hasAccess={ hasAccess }
                                             openFullScreenCard={ openFullScreenCard }
                                             type={ data.type }
                                             src={ item }
                                             height={ height }
                                             isLockedForSFW={ isLockedForSFW }
                                             onClickVerifyButton={ onClickVerifyButton }
                                          />
                                       ) : (
                                          <StoryCard
                                             lastItem={ index === imgData.length - 1 }
                                             src={ item }
                                             thumbnail={ data.full_thumbnail }
                                             type={ data.type }
                                             viewCount={ data.views_count || 0 }
                                             likeCount={ data.likes_count || 0 }
                                             commentsCount={ data.comments_count || 0 }
                                             title={ data.title }
                                             date={ data.publish_date }
                                             hideAfterMinutes={ data.hide_after_minutes }
                                             hasAccess={ hasAccess }
                                             isAdmin={ isAdmin }
                                             identifier={ identifier }
                                             deleteStory={ () => { openDeleteConfirmModal(data.id, true) } }
                                             openModal={ openModal }
                                             onClickComment={ onClickComment }
                                             onClickJoin={ onClickJoin }
                                             onClickOptions={ (isMultiple, id) => onClickOptions(isMultiple, id) }
                                             onClickLike={ onClickLike }
                                             onClickShare={ onClickShare }
                                             openFullScreenCard={ openFullScreenCard }
                                             isLiked={ isLiked }
                                             isAuthUsers={ isAuthUsers }
                                             isMultiple={ isMultipleCard }
                                             openStoryComments={ openStoryComments }
                                             desktopType={ desktopType }
                                             openDeleteConfirmModal={ openDeleteConfirmModal }
                                             shareStory={ shareStory }
                                             siteInfo={ siteInfo?.content_card_settings }
                                          />
                                       )
                                    }
                                 </>
                              )
                           }
                           {
                              type === 'fullScreen' && (
                                 <>
                                    {imgData.length === 1 && (
                                       <div className='fullScreen_line absolute w-screen z-20 flex px-3'>
                                          <div className='h-full flex-1 bg-panel dark:bg-panel-dark' />
                                       </div>
                                    )
                                    }
                                    <ImageContent
                                       src={ item }
                                       thumbnail={ data.full_thumbnail }
                                       type={ data.type }
                                       viewCount={ data.views_count || 0 }
                                       likeCount={ data.likes_count || 0 }
                                       title={ data.title }
                                       date={ data.publish_date }
                                       hideAfterMinutes={ data.hide_after_minutes }
                                       hasAccess={ hasAccess }
                                       isAdmin={ isAdmin }
                                       commentsCount={ data.comments_count || 0 }
                                       identifier={ data.id }
                                       deleteStory={ () => { openDeleteConfirmModal(data.id, true) } }
                                       openModal={ openModal }
                                       onClickComment={ onClickComment }
                                       onClickJoin={ onClickJoin }
                                       onClickOptions={ onClickOptions }
                                       onClickLike={ onClickLike }
                                       onClickShare={ onClickShare }
                                       onClose={ onClose }
                                       isLiked={ isLiked }
                                       onDeleteStory={ () => { openDeleteConfirmModal(data.id, true) } }
                                       onDeleteImage={ !!onDeleteImage ? () => onDeleteImage(index) : null }
                                       isAuthUsers={ isAuthUsers }
                                       isMultiple={ isMultipleCard }
                                       openStoryComments={ openStoryComments }
                                       siteInfo={ siteInfo?.content_card_settings }
                                       isLockedForSFW={ isLockedForSFW }
                                    />
                                 </>
                              )
                           }
                        </div>
                     )
                  })}
                  {
                     type === 'image' && children
                  }
               </Carousel>
               {
                  isStoryCarusel && isShowBottomContent && (
                     <div className='absolute bottom-0 left-0 w-full'>
                        <StoryBottomContent
                           commentsCount={ data.comments_count || 0 }
                           onClickComment={ onClickComment }
                           onClickLike={ onClickLike }
                           onClickShare={ onClickShare }
                           isAdmin={ isAdmin }
                           viewCount={ data.views_count || 0 }
                           likeCount={ data.likes_count || 0 }
                           isLiked={ isLiked }
                           onClickOptions={ () => onClickOptions(true, identifier) }
                           hasAccess={ hasAccess }
                           isAuthUsers={ isAuthUsers }
                           isMultiple={ isMultipleCard }
                           openStoryComments={ openStoryComments }
                           onClickTip={ onClickTip }
                           id={ id }
                           totalTip={ totalTip }
                           onClickOpenTips={ onClickOpenTips }
                           onClickSetId={ onClickSetId }
                           data={ data }
                           onShare={ onShare }
                           siteInfo={ siteInfo?.content_card_settings }
                           isInsideModal={ isInsideModal }
                           isChecked={ isChecked }
                           onSelectItem={ onSelectItem }
                        />
                     </div>
                  )
               }
            </div>
         </div>
      );
   }
}

const ImageStoryContent = ({
   hasAccess,
   openFullScreenCard,
   type,
   src,
   height,
   justify,
   isLockedForSFW,
   onClickVerifyButton,
}) => {

   const [isHoveredOnTheImage, setIsHoveredOnTheImage] = useState(false)

   return (
      <div
         className='focus-outline-card focus:outline-none h-full rounded-lg'
         onMouseEnter={ () => setIsHoveredOnTheImage(true) }
         onMouseLeave={ () => setIsHoveredOnTheImage(false) }
      >
         <div className={ `rounded-lg flex flex-col h-${ height } justify-${ justify } relative overflow-hidden` }>
            <div className='absolute z-10 rounded-lg w-full h-full overflow-hidden cursor-pointer'>
               <div
                  className='w-full h-full absolute top-0 z-10'
                  role='presentation'
                  onClick={ hasAccess && (() => openFullScreenCard(type)) }
               />
               <ImageStoryCardContent
                  src={ src }
                  isLockedForSFW={ isLockedForSFW }
                  isHoveredOnTheImage={ isHoveredOnTheImage }
                  onClickVerifyButton={ onClickVerifyButton }
               />
            </div>
         </div>
      </div>
   )
}

ImageStoryContent.propTypes = {
   hasAccess: PropTypes.bool,
   openFullScreenCard: PropTypes.func,
   type: PropTypes.string,
   src: PropTypes.string,
   height: PropTypes.oneOfType([
      'number',
      'string',
   ]),
   justify: PropTypes.oneOf([
      'between',
      'end',
      'center',
      'start',
      'around',
   ]),
   isLockedForSFW: PropTypes.bool,
   onClickVerifyButton: PropTypes.func,
}

ImageStoryContent.defaultProps = {
   height: 100,
   justify: 'between',
}

SimpleSlider.propTypes = {
   data: PropTypes.any,
   arrowIconColor: PropTypes.string,
   naturalHeight: PropTypes.number,
   naturalWidth: PropTypes.number,
   infinite: PropTypes.bool,
   type: PropTypes.string,
   onClickComment: PropTypes.func,
   openModal: PropTypes.func,
   deleteStory: PropTypes.any,
   onClickJoin: PropTypes.func,
   onClickLike: PropTypes.func,
   onClickShare: PropTypes.func,
   onClickOptions: PropTypes.func,
   openFullScreenCard: PropTypes.func,
   onClose: PropTypes.func,
   nextStory: PropTypes.func,
   onDeleteStory: PropTypes.func,
   isAdmin: PropTypes.bool,
   isLiked: PropTypes.bool,
   isAuthUsers: PropTypes.bool,
   hasAccess: PropTypes.bool,
   onDeleteImage: PropTypes.func,
   children: PropTypes.any,
   openStoryComments: PropTypes.func,
   isLoading: PropTypes.bool,
   initialSlideNumber: PropTypes.number,
   onSliderChange: PropTypes.func,
   desktopType: PropTypes.string,
   openDeleteConfirmModal: PropTypes.func,
   shareStory: PropTypes.func,
   identifier: PropTypes.number,
   isAutoplay: PropTypes.bool,
   isShowTopContent: PropTypes.bool,
   isShowBottomContent: PropTypes.bool,
   screenWidth: PropTypes.number,
   isDots: PropTypes.bool,
   height: PropTypes.oneOfType([
      'number',
      'string',
   ]),
   activeStory: PropTypes.object,
   insideHomepage: PropTypes.bool,
   onClickTip: PropTypes.func,
   id: PropTypes.number,
   totalTip: PropTypes.number,
   onClickOpenTips: PropTypes.func,
   onClickSetId: PropTypes.func,
   onShare: PropTypes.func,
   siteInfo: PropTypes.object,
   isLockedForSFW: PropTypes.bool,
   isInsideModal: PropTypes.bool,
   isChecked: PropTypes.bool,
   isAgeVerificationRequired: PropTypes.bool,
   onSelectItem: PropTypes.func,
   onClickVerifyButton: PropTypes.func,
};
SampleNextArrow.propTypes = {
   onClick: PropTypes.func,
   clearInterval: PropTypes.func,
   currentSlide: PropTypes.number,
   carouselState: PropTypes.object,
   type: PropTypes.string,
};
SamplePrevArrow.propTypes = {
   onClick: PropTypes.func,
   clearInterval: PropTypes.func,
   currentSlide: PropTypes.number,
   carouselState: PropTypes.object,
};
SimpleSlider.defaultProps = {
   initialSlideNumber: 0,
   customSettings: {},
   isAutoplay: false,
   isShowTopContent: true,
   isShowBottomContent: true,
   isDots: false,
}

const mapStateToProps = (state) => {
   return {
      screenWidth: screenWidthSelector(state),
   }
}

export default  connect(mapStateToProps, null)(SimpleSlider)
